import axios from "axios";
import cookie from 'react-cookies';

// getHost() originates from internal Utility Portal.
// If a REACT_APP_HOST is not provided, we use the
// protocol, web server host, and REACT_APP_SERVICE_ROOT
// to build the base path for API calls.
export function getHost() {
    if (process.env.REACT_APP_LOCALAPP) {
        return 'http://localhost:3001';
    }

    if (process.env.REACT_APP_HOST === '') {
        // window.location.origin may not be available in IE
        let url = `${window.location.protocol}//${window.location.host}/`;

        return url + process.env.REACT_APP_SERVICE_ROOT;
    } else {
        return process.env.REACT_APP_HOST;
    }
}

const storeAuthToken = (token) => {
    return Promise.resolve(window.sessionStorage.setItem('token', token));
}

const getAuthToken = () => {
    return window.sessionStorage.getItem('token');
}

export const api = axios.create({
    baseURL: getHost(),
    withCredentials: true
});

api.interceptors.request.use(
	config => {
		config.headers = {
			...config.headers,
			'X-XSRF-TOKEN': getAuthToken()
		};
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

api.interceptors.response.use(
	response => {
        let existingToken = getAuthToken();
        let csrfCookie = cookie.load('XSRF-TOKEN')
		if(csrfCookie && csrfCookie !== existingToken){
			storeAuthToken(csrfCookie);
		}
		return response;
	},
	error => {
		return Promise.reject(error);
	}
);
